import React from 'react'
import PropTypes from 'prop-types'
import Snackbar from '@material-ui/core/Snackbar'
import { Button, Slide, Typography } from '@material-ui/core'
import styled from 'styled-components'
import theme from '../../utils/theme'

const MessageContainer = styled(Snackbar)`
  &.MuiSnackbar-root {
    ${theme.breakpoints.up('sm')} {
      position: absolute;
    }
  }
  &.error .MuiSnackbarContent-root {
    background-color: ${props => props.theme.palette.error.main};
  }
  &.success .MuiSnackbarContent-root {
    background-color: ${props => props.theme.palette.success.main};
  }
`

const TransitionUp = props => <Slide {...props} direction="up" />

const handleAction = (variant, onClose, onSuccess) => {
  if (variant === 'loading') {
    return
  }
  if (variant === 'success') {
    return (
      <Button key="keep" size="small" color="inherit" onClick={onSuccess}>
        Keep Bets
      </Button>
    )
  }

  return (
    <Button key="deposit" size="small" color="inherit" onClick={onClose}>
      Deposit
    </Button>
  )
}

const MessageSnackBar = props => {
  const { messageHub, onClose, onSuccess, ...other } = props

  const { open, message, variant } = messageHub

  return (
    <MessageContainer
      className={variant}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      open={open}
      autoHideDuration={6000}
      TransitionComponent={TransitionUp}
      onClose={onClose}
      ContentProps={{
        'aria-describedby': 'betslip-message',
      }}
      message={
        <Typography variant="subtitle2" id="betslip-message">
          {message}
        </Typography>
      }
      action={handleAction(variant, onClose, onSuccess)}
      {...other}
    />
  )
}

MessageSnackBar.propTypes = {
  messageHub: PropTypes.object,
  onClose: PropTypes.func,
  onSuccess: PropTypes.func,
}

export default MessageSnackBar
